module.exports = __webpack_public_path__ + "assets/16016753b546065bbf6c3ab01d4c56a7.png";